import {CopilotIcon, SlidersIcon} from '@primer/octicons-react'
import {useSelectedModel} from '../../../hooks/use-selected-model'
import {getReasoningEffortLabel} from '@github-ui/copilot-shared-ui/utils/reasoning-effort'
import type {ModelChangeMarker} from './model-change-marker'
import styles from './ModelChangeStatusEntry.module.css'

export function ModelChangeStatusEntry({marker}: {marker: ModelChangeMarker}) {
  const model = useSelectedModel(marker.modelId)

  return (
    <div className={styles.row} data-testid={`ahp-${marker.kind}-change-status`}>
      <span className={styles.icon}>
        {marker.kind === 'model' ? (
          <CopilotIcon size={16} aria-hidden="true" />
        ) : (
          <SlidersIcon size={16} aria-hidden="true" />
        )}
      </span>
      {marker.kind === 'model' ? (
        <span className={styles.text}>
          Model changed to <span className={styles.emphasis}>{model?.displayName ?? marker.modelId}</span>{' '}
          <span className={styles.emphasis}>{getReasoningEffortLabel(marker.reasoningEffort)}</span>
        </span>
      ) : (
        <span className={styles.text}>
          Reasoning effort changed from{' '}
          <span className={styles.emphasis}>{getReasoningEffortLabel(marker.fromReasoningEffort)}</span> to{' '}
          <span className={styles.emphasis}>{getReasoningEffortLabel(marker.toReasoningEffort)}</span>
        </span>
      )}
    </div>
  )
}
